<template>
  <div class="content-430 page-index">
    <div class="base-info">
      <BaseDetailsInfo
        ref="baseDetailsInfo"
        :config-id="configId"
        :create-time="createTime"
        :operate-time="operateTime"
        :operator-name="operatorName"
        @on-details="onGetDetails"
      ></BaseDetailsInfo>
      <div class="head">课配置课程提供方：</div>
      <RemarkCard style="margin-bottom: 10px">
        <h3 class="color-red" style="margin-bottom: 10px">提示：</h3>
        <p style="margin-bottom: 6px">
          【1】支持设置课程提供方对应的支付订单资金入账到<span class="color-red">指定的账户方。</span>
        </p>
        <p style="margin-bottom: 6px">
          【2】针对线下结算类型，支持设置线下分账比例，该比例将用户课程提供方账单生成使用
        </p>
        <p>【3】对于学校作为资金入账方，请选择学校在资管侧的进件商户。</p>
      </RemarkCard>
      <div class="flex justify-content_end" style="margin-bottom: 10px">
        <Button type="primary" @click="handleAddOrg">添加课程提供方</Button>
      </div>
      <div class="table-wrap">
        <Table :columns="columns" :data="tableList" border>
          <template slot="divideChannel" slot-scope="{ row, index }">
            <span>{{ row.divideChannel == 2 ? '线下结算' : '线上结算' }}</span>
          </template>
          <template slot="divideInfoList" slot-scope="{ row, index }">
            <span>{{
              getDivideInfoStr(row.divideChannel, row.divideInfoList)
            }}</span>
          </template>
          <template slot="accountingType" slot-scope="{ row, index }">
            <TablePoptip :content="getAccountingTypeStr(row)"> </TablePoptip>
          </template>
          <template slot="action" slot-scope="{ row, index }">
            <span
              v-if="row.divideChannel == 2"
              class="click-btn-430"
              @click="handleEdit(row)"
            >编辑</span>
            <span
              class="click-btn-430"
              style="color: red"
              @click="handleDelete(row)"
            >删除</span>
          </template>
        </Table>
      </div>
      <div class="page-wrap">
        <Page
          :current="pageInfo.pageNum"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          show-total
          show-elevator
          show-sizer
          :page-size-opts="pageSizeOpts"
          @on-change="pageChange"
          @on-page-size-change="handleSizeChange"
        ></Page>
      </div>
    </div>
    <div class="formbtnbox-430-bottom">
      <Button @click="handleGoBack">返回</Button>
    </div>
    <ActionOrgModal
      ref="actionOrgModalRef"
      :in-account-type="inAccountType"
      :config-id="configId"
      :bank-id="bankId"
      :bank-name="bankName"
      :details-info="detailsInfo"
      :config-table-list="tableList"
      :config-org-list="configOrgList"
      :is-material-show="isMaterialShow"
      @on-finish="onActionOrgFinish"
    ></ActionOrgModal>
    <EditOrgModal
      ref="editOrgModalRef"
      :is-material-show="isMaterialShow"
      @on-finish="onEditOrgFinish"
    ></EditOrgModal>
    <Modal
      v-model="showHint"
      :mask-closable="false"
      title="温馨提示"
      width="460"
      :closable="false"
    >
      <div>
        <!-- <h2 style="margin-bottom: 4px">提示：</h2> -->
        <p style="margin-bottom: 6px">
          1、选择资金入账方（收款单位），对应课程提供方的收款将收款至指定的账户，该账户是实体资金账户。
        </p>
        <p style="margin-bottom: 6px">
          2、如果需要入账方（收款单位）进行结算打款，请务必选择在430业务系统侧已绑定的的账号，否则无法进行结算账单审批。
        </p>
        <p style="margin-bottom: 6px">
          3、线下分账模式，支持多方分账，请设置前仔细核对！
        </p>
        <h1>请确定您已知晓上述说明！</h1>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          size="large"
          long
          @click="showHint = false"
        >我已知晓上述说明！</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import orderCenterApi from '@/request/orderCenter/index.js';
import { getAddDate } from '@/utils/moment';
import { MATERIAL_TYPES } from './assets/data/index';
export default {
  components: {

    BaseDetailsInfo: () =>
      import('./assets/components/BaseDetailsInfo.vue'),
    ChooseOrgModal: () =>
      import('./assets/components/ChooseOrgModal.vue'),
    ActionOrgModal: () =>
      import('./assets/components/ActionOrgModal.vue'),
    RemarkCard: () =>
      import('@c/Base/RemarkCard.vue'),
    EditOrgModal: () =>
      import('./assets/components/EditOrgModal.vue')

  },
  data() {
    return {
      inAccountType: this.$route.query.inAccountType,
      configId: this.$route.query.configId,
      bankId: this.$route.query.bankId,
      bankName: this.$route.query.bankName,
      createTime: this.$route.query.createTime,
      operateTime: this.$route.query.operateTime,
      operatorName: this.$route.query.operatorName,
      tableList: [],
      pageSizeOpts: [10, 20, 50, 100],
      showHint: true,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      columns: [{
        type: 'index',
        title: '序号',
        width: 70,
        align: 'center'
      }, {
        title: '入账分账方（账户方）',
        key: 'orgName',
        minWidth: 230
      }, {
        title: '课程提供方',
        minWidth: 230,
        key: 'offerOrgName'
      }, {
        title: '结算方式',
        width: 120,
        slot: 'divideChannel'
      }, {
        title: '账期',
        width: 250,
        slot: 'accountingType'
      }, {
        title: '线下分账比例',
        width: 210,
        slot: 'divideInfoList'
      }, {
        title: '操作',
        width: 150,
        slot: 'action'
      }],
      isSaveing: false,
      formData: {
        accountingType: '1',
        customCycle: 7,
        customCycleBegin: ''
      },
      accountingCustomCycleBegin: '', // 时间控件 value
      cacheCustomCycle: '', // 编辑 缓存冻结时间
      cacheAccountingCustomCycleBegin: '', // 编辑 缓存结算起始时间
      type: 'add', //
      configOrgList: [],
      detailsInfo: null,
      materialRadio: '1'

    };
  },
  computed: {
    disabledDatePicker() {
      return !!this.accountingCustomCycleBegin;
    },
    // 是否是材料费类规则
    isMaterialShow() {
      return this.detailsInfo && this.detailsInfo.itemType == 2;
    }

  },
  created() {
    this.getDivideConfigOrgPage();
  },
  mounted() {
    //
  },
  methods: {
    handleAddOrg() {
      this.$refs.actionOrgModalRef.handleOpen(this.detailsInfo);
    },
    getAccountingTypeStr(row) {
      if (this.isMaterialShow) {
        return row.accountingNum == 0 ? '按所绑定的课程商品课时分多次结算' : `按${row.accountingNum}个课时（一次性或多次）结算`;
      }
      return row.accountingType == 1
        ? '按月考勤节次'
        : `按固定时长,冻结时间${row.accountingCustomCycle}天,结算起始时间：${row.accountingCustomCycleBegin}`;
    },
    async handleDelete(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确定删除？</p>',
        onOk: () => {
          orderCenterApi.deleteRelById({
            relId: row.relId
          }).then(res => {
            if (res.status == 200) {
              this.$Message.success('删除成功');
              if (this.tableList.length < 2) {
                this.pageInfo.pageNum = 1;
              }
              this.getDivideConfigOrgPage();
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    handleEdit(row) {
      this.$refs.editOrgModalRef.handleShow(row);
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getDivideConfigOrgPage();
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getDivideConfigOrgPage();
    },
    getDivideInfoStr(type, val) {
      const arr = [];
      val && val.forEach(item => {
        arr.push(`${item.typeName}:${item.proportion / 100}%`);
      });
      return type != 2 ? '--' : arr.join('；');
      //  let
    },
    async getDivideConfigdOrgList() {
      const res = await orderCenterApi.getDivideConfigdOrgList({
        configId: this.configId
      });
      if (res.status == 200) {
        this.configOrgList = res.message;
      }
    },
    async getDivideConfigOrgPage() {
      return new Promise(async(resolve, reject) => {
        const res = await orderCenterApi.getDivideConfigOrgPage({
          configId: this.configId,
          pageNo: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize
        });
        this.getDivideConfigdOrgList();
        if (res.status == 200) {
          res.message.list.forEach(item => {
            item.divideInfoList && item.divideInfoList.forEach(item_1 => {
              if (item_1.orgId == item.offerOrgId) {
                item_1.typeName = '课程方';
                item_1.type = 1;
              } else {
                if (item_1.orgType == 6) {
                  item_1.typeName = '平台';
                  item_1.type = 2;
                } else {
                  item_1.typeName = item_1.orgName;
                  item_1.type = 3;
                }
              }
            });
            item.divideInfoList = item.divideInfoList.sort((a, b) => { return a.type - b.type; });
          });
          console.log(res.message.list, 'tableList');
          this.tableList = res.message.list;
          this.pageInfo.total = Number(res.message.total);
          //   this.initTableData(res.message);
          resolve();
        }
      });
    },
    onActionOrgFinish() {
      this.pageInfo.pageNum = 1;
      this.getDivideConfigOrgPage();
    },
    onEditOrgFinish() {
      this.getDivideConfigOrgPage();
    },
    // 详情
    onGetDetails(info) {
      this.detailsInfo = info;
    },
    // 提交关联主分账方
    // 输入框失焦
    handleInputNumberBlur() {
      if (this.formData.customCycle < 7) {
        this.formData.customCycle = 7;
      }
    },
    // 输入框值变化
    handleInputNumberChange(num) {
      if (this.type == 'add') {
        return null;
      }
      if (num == this.cacheCustomCycle) {
        this.formData.customCycleBegin = this.cacheAccountingCustomCycleBegin;
        this.accountingCustomCycleBegin = this.cacheAccountingCustomCycleBegin;
      } else {
        this.formData.customCycleBegin = getAddDate();
        this.accountingCustomCycleBegin = getAddDate();
      }
    },
    handleCheckAllForm() {

    },
    handleGoBack() {
      this.$router.push({
        name: 'orderCenter_profitSharing_index'
      });
    },

    // 配置账期周期 结算起始时间 变化
    onDateChange(date) {
      this.formData.customCycleBegin = date;
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  background: rgb(247, 248, 250);
  line-height: 40px;
  font-weight: 700;
  padding: 0 20px;
  margin-bottom: 16px;
}
.page-index {
  padding-bottom: 100px !important;
}
</style>
